<app-header></app-header>
<app-leftsidebar></app-leftsidebar>
<div class="common-page-main">
  <div class="common-herobanner">
    <img src="assets/images/cpbanner.png" alt="">
  </div>
  @if (!isAbout) {
    <div class="right-sec common-right-sec right-slide">
      <div class="common-right-sec-bg">
        <div class="common-sec-heading">
          <h2>LEARN MORE</h2>
          <div class="common-btn-sec">
            <a class="btn btn-dark" routerLink="/home">Back</a>
          </div>
        </div>
        <div class="common-content">
          <h3>Overview</h3>
          <p>WorldTumbler is a Digital Mapping Platform for your fantasy worlds. Designed to revolutionize map-making for
            tabletop role-playing games (TTRPGs) across all genre's. Whether you're a Game Master leading epic quests, a
            player exploring uncharted realms, or a world builder designing a complex universe, WorldTumbler offers the
          ultimate solution for crafting immersive, interactive maps.</p>
          <p>With WorldTumbler, you can design breathtaking, multi-layered maps that bring your worlds to life. From
            sprawling continents to intricate dungeons, our intuitive interface and powerful tools empower creators of all
            skill levels to seamlessly build, share, and enhance their campaigns. Explore the future of TTRPG map-making
          and discover how WorldTumbler can elevate your storytelling. Learn More About Our Vision.</p>
          <p>At its core, WorldTumbler thrives on a vibrant, community-driven ecosystem. Players, Game Masters, and
            Creators can contribute to and explore shared worlds, each rich with unique geography, cultures, characters,
            adventures and interwoven storylines. Collaborate, connect, and discover endless opportunities as you immerse
          yourself in an ever-expanding tapestry of community-generated worlds and adventures.</p>
          <h3>Features</h3>
          <p>Help you craft interactive, layered maps filled with geographical data and customizable content. Incorporate
            dynamic elements like fog of war and map markers to bring your world to life while maintaining enough control
          over the gameplay experience.</p>
          <p>Leverage community-built content, including modules, NPCs, and pre-designed assets, to enhance your campaigns
            effortlessly. Collaborate with others or draw inspiration from a library of shared creations to make your
          adventures even more engaging.</p>
          <p>Our multi-layer system offers Game Masters the power to toggle between player and GM-only views, keeping
            surprises intact and adding depth to every session. Link lore, quests, and character notes directly to map
            elements for seamless integration, and track your campaign's progress with tools that organize your storyline
          chronologically. Explore the ultimate platform for immersive TTRPG storytelling. Explore All Features.</p>
          <h3>Benefits</h3>
          <p>WorldTumbler transforms your TTRPG experience with dynamic, interactive maps that bring your world to life
            and capture the essence of your gameplay narrative. While traditional VTTs focus on the finer points of
            combat, WorldTumbler takes a broader approach, enriching the immersive world-building that supports and
          enhances those VTT systems. </p>
          <p>Save time with automation tools like terrain generation, asset libraries, and map templates. Focus more on
          storytelling and gameplay while the platform handles the heavy lifting. See How It Saves Time</p>
          <h3>Use Cases</h3>
          <p>For Game Masters: Plan intricate campaigns, build battle maps, and manage exploration areas with ease. Use
            visibility layers to unveil secrets only when the story demands it, keeping players intrigued and immersed.
          </p>
          <p>For Players: Navigate the world like never before. WorldTumbler offers an engaging way to explore,
          strategize, and interact with the game world, making every session memorable. See Use Cases</p>
          <h3>Support</h3>
          <p>Send email to Support&#64;worldtumbler.com and we'll do our best to work with you!<br>
            We're constantly improving the platform and welcome your feedback. Hoping to have a roadmap posted soon.<br>
            About Us<br>
            WorldTumbler are passionate TTRPG enthusiasts dedicated to creating tools that enhance storytelling and bring
            fantasy worlds to life.<br>
            Our mission is to empower creators with innovative features that save time and elevate gameplay.<br>
            Founded by gamers for gamers, owe understand the challenges (and joys) of TTRPGs.<br>
          We are committed to building a supportive community and delivering the best mapping experience possible.</p>
          <h3>Acknowledgement</h3>
          <p>We extend our gratitude to a few creators and ask that you support these in their ongoing effort to make your worlds better.</p>
          <p>
            -- Azgaar! Creator of Azgaar's Fantasy Map Generator
            <a href="https://azgaar.github.io/Fantasy-Map-Generator/">https://azgaar.github.io/Fantasy-Map-Generator/</a>
            - An open-source tool that enables users to design, modify, and personalize intricate fantasy maps, utilizing a wide array of generative options including terrain, culture, religion, and political features.
            Patreon: Azgaar's Patreon
            <a href="https://www.patreon.com/azgaar">https://www.patreon.com/azgaar</a>
          </p>
          <p>
            -- Watabou! Creator of Procgen Arcana
            <a href="https://watabou.github.io/">https://watabou.github.io/</a>
            - A collection of free, actively developed map generators designed for tabletop role-playing games and worldbuilding, featuring various tools to create diverse environments like cities, villages, and dungeons.
            Patreon: Watabou's Patreon
            <a href="https://www.patreon.com/watabou">https://www.patreon.com/watabou</a>
          </p>
          <p>Their work and innovative tools have inspired and supported countless creators in the TTRPG community, including WorldTumbler. If you appreciate their contributions, please consider supporting them! Together, we're building incredible worlds.</p>
        </div>
      </div>
    </div>
  } @else {
    <div class="right-sec common-right-sec right-slide">
      <div class="common-right-sec-bg">
        <div class="common-sec-heading">
          <h2>ABOUT WorldTumbLer</h2>
          <div class="common-btn-sec">
            <a class="btn btn-dark" routerLink="/home">Back</a>
          </div>
        </div>
        <div class="common-content">
          <p>Welcome to WorldTumbler, a collaborative mapping platform designed specifically for the tabletop
            role-playing game (TTRPG) community. Our journey as lifelong TTRPG enthusiasts began in 1979 with Dungeons &
            Dragons First Edition, expanding to include beloved classics like Top Secret, Car Wars, Call of Cthulhu,
          Gamma World, Champions, and the whimsical chaos of Cheapass Games.</p>
          <p>During long weekends, my best friend's parents, Barbara and Flash, would drive us from Santa Cruz,
            California, to Los Angeles. There, we would visit a hobby shop named "La Maison de Guerre," if I recall
            correctly. This trip was a significant event that occurred a few times a year and involved copious amounts
            of Coca-Cola, McDonald's meals, and sleep-deprived debates over tape measurements and home brew rules.
            Picture a mid-sized hobby store, display cases pushed aside to make room for six 4x8 plywood sheets, painted
            and stacked precariously with painted miniatures and reenactment battles. Being hobby shop, it was
            well-stocked and first assignment was unpacking another hundred cavalry (or which ever was needed) figures
            from inventory to showcase a newly assembled regiments. The popularity of Dungeons & Dragons in the late
            80's brought magic and monsters into our miniature gaming experiences and I was hooked. Although times have
            changed, our love for gathering around tables for spirited discussions and cooperative objectives remains
          strong.</p>
          <p>Launched in 2019, WorldTumbler was created with a straightforward vision: to inspire shared storytelling
            and foster community connections. Drawing inspiration from the 1980s Judges Guild supplements—known for
            pairing detailed maps for game masters with blank maps for players—we aimed to recapture that sense of
            discovery while making it more accessible in today's digital landscape.
          </p>
          <p>At its heart, WorldTumbler emphasizes collaboration. Game Masters who design intricate worlds while players
            explore and interact with these creations. The community can share, remix, and build upon each other's
            ideas. Whether you're crafting a vast empire, a lively port town, or a concealed dungeon, WorldTumbler
          facilitates contributions to an evolving tapestry of shared worlds of any genre.</p>
          <p>We believe that the most enriching TTRPG experiences stem from collective imagination and storytelling.
            WorldTumbler is not merely a tool; it is meant to be a space where creators, players, and fans can share,
            inspire one another, and collaboratively shape worlds. Join us in cultivating a vibrant community where your
          maps and ideas ignite adventures for groups everywhere.</p>
        </div>
      </div>
    </div>
  }
</div>
<app-footer></app-footer>